import '@hotwired/turbo-rails'
import '../js/initTippy'
import '../js/initSlimSelect'
import '../js/initTagify'
import initAlpine from '../js/initAlpine'
import initIntlTelInput from '../js/initIntlTelInput'

initAlpine()

document.addEventListener('turbo:load', () => {
  initIntlTelInput()
})
